import { render } from "./dumb-modal.template.html?vue&type=template&id=78415752&scoped=true"
import script from "./DumbModal.vue?vue&type=script&lang=js"
export * from "./DumbModal.vue?vue&type=script&lang=js"

import "./DumbModal.vue?vue&type=style&index=0&id=78415752&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78415752"

export default script